import React, { useEffect, useState, useRef } from 'react';
import { CHAT } from 'common/config-api';

/**
 * POS 상품 정보 컴포넌트
 */
const PosContentsProduct = ({ product }) => {
  return (
    <tr key={product.productIdx}>
      <td>
        {product.productName} <code>{product.productManufactureNickname}</code>
        <p className="card-text">
          <b>￥{product.productPrice?.toLocaleString()} * {product.salesProductQuantity}</b>
        </p>
      </td>
      <td style={{ textAlign: 'right' }}>
        ￥{(product.salesProductQuantity * product.productPrice)?.toLocaleString()}
      </td>
    </tr>
  );
};

/**
 * POS 계산기 리뷰 컴포넌트 (고객용 화면)
 * WebSocket으로 실시간 구매 정보를 표시합니다.
 */
export default function PosCalculatorReview() {
  const chatUrl = `${CHAT.CHAT_URL}`;

  const [cssPosInfo, setCssPosInfo] = useState('none');
  const [cssCompleteInfo, setCssCompleteInfo] = useState('none');
  const [cssWaitInfo, setCssWaitInfo] = useState('block');
  const [username, setUsername] = useState('비회원');
  const [productList, setProductList] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [salesReceived, setSalesReceived] = useState(0);
  const [salesChange, setSalesChange] = useState(0);

  const socketRef = useRef(null);

  // 메인 요소 스타일 조정
  const mainElement = document.getElementById('main');
  if (mainElement) {
    mainElement.style.marginTop = '0';
  }

  /**
   * WebSocket 메시지 처리
   */
  const dataProcess = (data) => {
    if (typeof data === 'string') {
      if (data === 'purchase') {
        setCssPosInfo('none');
        setCssCompleteInfo('block');
        reviewRefresh();
      }
    } else if (typeof data === 'object') {
      setProductList(data.salesProducts);
      setTotalPrice(data.salesPrice);
      setSalesReceived(data.salesReceived);
      setSalesChange(data.salesChange);
      setUsername(data.userName);
    }
  };

  useEffect(() => {
    // 헤더 제거
    const headElement = document.getElementById('header');
    if (headElement) {
      headElement.remove();
    }

    // WebSocket 연결
    socketRef.current = new WebSocket(chatUrl);

    socketRef.current.onopen = () => {
      const talkMsg = {
        type: 'TALK',
        roomId: 'girieno',
        sender: 'chee',
        msg: 'connenct'
      };
      socketRef.current.send(JSON.stringify(talkMsg));
    };

    socketRef.current.onmessage = (event) => {
      const parsedData = JSON.parse(event.data);
      if (parsedData.msg !== 'connenct') {
        setCssPosInfo('block');
        setCssWaitInfo('none');
      }
      dataProcess(parsedData.msg);
    };

    socketRef.current.onerror = (error) => {
      console.error('WebSocket 에러:', error);
    };

    socketRef.current.onclose = () => {
      setTimeout(() => {
        if (!socketRef.current || socketRef.current.readyState === WebSocket.CLOSED) {
          socketRef.current = new WebSocket(chatUrl);
        }
      }, 3000);
    };

    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, []);

  /**
   * 결제 완료 후 화면 새로고침
   */
  const reviewRefresh = () => {
    setTimeout(() => window.location.reload(), 5000);
  };

  return (
    <div className="col-lg-12">
      {/* 대기 화면 */}
      <div className="card" id="waitInfo" style={{ display: cssWaitInfo }}>
        <div className="card-body">
          <img
            src="/images/sikaring_01.png"
            alt="대기"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </div>
      </div>

      {/* 결제 완료 화면 */}
      <div className="card" id="completeInfo" style={{ display: cssCompleteInfo }}>
        <div className="card-body">
          <h1>결제완료안내!!!!!!</h1>
        </div>
      </div>

      {/* 구매 정보 화면 */}
      <div className="card" id="posInfo" style={{ display: cssPosInfo }}>
        <div className="card-body">
          <h5 className="card-title">{username}님의 구매내역</h5>
          <table className="table">
            <tbody>
              {productList.length > 0 &&
                productList.map((value, index) => (
                  <PosContentsProduct key={value.productIdx || index} product={value} />
                ))}

              <tr>
                <th colSpan="2"></th>
              </tr>

              <tr>
                <th scope="row" style={{ paddingTop: '2rem', fontWeight: 600, fontSize: '3em' }}>
                  총금액
                </th>
                <td style={{ paddingTop: '.5rem', paddingBottom: '.5rem', textAlign: 'right' }}>
                  <span style={{ color: '#0d6efd', fontWeight: 600, fontSize: '5em' }}>
                    {totalPrice.toLocaleString('ko-KR')}
                  </span>
                </td>
              </tr>

              <tr>
                <th scope="row" style={{ paddingTop: '1.5rem', fontWeight: 600, fontSize: '3em' }}>
                  받은금액
                </th>
                <td style={{ textAlign: 'right', fontWeight: 600, fontSize: '4em' }}>
                  {salesReceived.toLocaleString('ko-KR')}
                </td>
              </tr>

              <tr>
                <th scope="row" style={{ paddingTop: '1.5rem', fontWeight: 600, fontSize: '3em' }}>
                  거스름돈
                </th>
                <td style={{ textAlign: 'right', fontWeight: 600, fontSize: '4em' }}>
                  {salesChange.toLocaleString('ko-KR')}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
